(() => {
  const guide = document.querySelector('[data-ogh-home-guide]');
  if (!guide) return;

  const form = guide.querySelector('[data-ogh-home-guide-form]');
  const results = guide.querySelector('[data-ogh-home-guide-results]');
  const candidates = [...guide.querySelectorAll('[data-ogh-guide-product]')];
  const title = guide.querySelector('[data-ogh-home-guide-title]');
  const summary = guide.querySelector('[data-ogh-home-guide-summary]');
  if (!form || !results || !title || !summary) return;

  const labels = {
    cabin: 'your cabin',
    tiny_home: 'your tiny home',
    rv: 'your RV',
    garage: 'your garage',
    workshop: 'your workshop',
    cargo_trailer: 'your trailer'
  };

  const updateProgress = () => {
    const answered = ['space', 'power'].filter((name) => form.elements[name].value).length
      + (form.elements.square_feet.value ? 1 : 0);
    guide.querySelector('.ogh-x-progress').textContent = answered === 3
      ? 'Ready when you are.'
      : `${3 - answered} ${3 - answered === 1 ? 'question' : 'questions'} to go.`;
  };
  form.addEventListener('change', updateProgress);
  form.addEventListener('input', updateProgress);

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (!form.reportValidity()) return;

    const data = new FormData(form);
    const space = data.get('space');
    const power = data.get('power');
    const squareFeet = Number.parseInt(data.get('square_feet'), 10);
    const capacity = data.get('capacity');
    const mobileSpace = space === 'rv' || space === 'cargo_trailer';
    let matches = 0;

    candidates.forEach((candidate) => {
      const applications = (candidate.dataset.applications || '').split(',');
      const capacityMatch = capacity === 'unknown' || candidate.dataset.capacity === capacity;
      const applicationMatch = mobileSpace || applications.includes(space) || (space === 'garage' && applications.includes('workshop'));
      const match = capacityMatch && applicationMatch;
      candidate.hidden = !match;
      if (match) matches += 1;
    });

    const sizeSentence = capacity === 'unknown'
      ? `At ${squareFeet.toLocaleString()} sq. ft., the windows, insulation, climate, and other details still need to be checked before choosing 9,000 or 12,000 BTU.`
      : `You told us the space needs about ${Number.parseInt(capacity, 10).toLocaleString()} BTU based on a heating and cooling load calculation.`;
    const powerSentence = power === 'grid'
      ? 'Confirm that the dedicated 115V circuit meets the requirements for the system you choose.'
      : `Make sure the full ${power} setup can handle the system, the other loads, and some extra room for difficult days.`;
    const mobileSentence = mobileSpace
      ? 'Because this is a moving vehicle, treat these as systems to compare—not a mounting recommendation. Vibration, road exposure, drainage, and electrical work need their own plan.'
      : '';

    title.textContent = `${matches} ${matches === 1 ? 'system is' : 'systems are'} worth comparing for ${labels[space]}.`;
    summary.textContent = `${sizeSentence} ${powerSentence} ${mobileSentence}`.trim();
    results.hidden = false;
    results.focus({ preventScroll: true });
    results.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    document.dispatchEvent(new CustomEvent('ogh_home_guide_completed', { detail: { tool: 'home_guide' } }));
  });

  form.addEventListener('reset', () => {
    candidates.forEach((candidate) => { candidate.hidden = false; });
    results.hidden = true;
    guide.querySelector('.ogh-x-progress').textContent = 'Three questions. No guessing.';
  });
})();
